
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  MenuItem,
  CircularProgress,
  Alert,
  FormControlLabel,
  Switch,
  Autocomplete,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../DataLayouts/Header";
import toast from "react-hot-toast";
import { fetchOrganizationDepartment } from "../../../Apis/Department-api";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import { MAIN_URL } from "../../../Configurations/Urls";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { format } from "date-fns";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fetchAttendanceBreakType } from "../../../Apis/Attendance";

function AttendanceBreakForm({ mode }) {
  const { id } = useParams(); // only used in edit mode
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(mode === "edit");
  const [btnLoading, setbtnLoading] = useState(false);
  const [BreakType, setBreakType] = useState([]);
  const { userData } = useAuthStore();
  const org = userData?.organization;

  const [formData, setFormData] = useState({
    organization_attendance_break_type_id: "",
    attendance_break_name: "",
    description: "",
    break_duration_minutes: "",
    break_start_time: "",
    break_end_time: "",
    is_paid: "",
  });

  useEffect(() => {
    {
      fetchAttendanceBreakType(org.organization_id)
        .then((data) => {
          setBreakType(data?.attendance_breaktype);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, []);

  let navigate = useNavigate();

  const toTimeHi = (value) => {
    if (!value) return "";
    const raw = String(value).trim();
    // Accept "HH:mm", "HH:mm:ss", or ISO-ish values and keep HH:mm
    const match = raw.match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
    if (!match) return raw;
    return `${match[1].padStart(2, "0")}:${match[2]}`;
  };

  useEffect(() => {
    let getdataById = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/organizations/${org.organization_id}/attendance-breaks/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const record = response?.data?.Attendancebreak || {};
        setFormData({
          ...record,
          break_start_time: toTimeHi(record.break_start_time),
          break_end_time: toTimeHi(record.break_end_time),
          is_paid: !!record.is_paid,
        });
      } catch (err) {
        console.error(err);
        toast.error("Failed to load attendance break.");
      } finally {
        setLoading(false);
      }
    };
    if ((mode === "edit" || mode === "view") && id) {
      setLoading(true);
      getdataById();
    }
  }, [mode, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_attendance_break_type_id)
      errors.organization_attendance_break_type_id =
        "Atendance break type is required.";

    if (!formData.attendance_break_name)
      errors.attendance_break_name = "Break Name is required.";

    if (!formData.break_duration_minutes)
      errors.break_duration_minutes = "Break duration is required.";

    if (!formData.break_start_time)
      errors.break_start_time = "Start time is required.";

    if (!formData.break_end_time)
      errors.break_end_time = "End time is required.";

    setFormErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setbtnLoading(true);

    const payload = {
      ...formData,
      break_start_time: toTimeHi(formData.break_start_time),
      break_end_time: toTimeHi(formData.break_end_time),
      is_paid: formData.is_paid ? 1 : 0,
    };

    try {
      if (mode === "edit") {
        // Call edit API
        await axios.put(
          `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-breaks/${id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      } else {
        await axios.post(
          `${MAIN_URL}/api/organizations/${org?.organization_id}/attendance-breaks`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }

      toast.success(
        mode === "edit"
          ? "Attendance Break Updated!"
          : "Attendance Break Created!"
      );
      setFormErrors({});
      navigate(-1);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Session Expired!");
        window.location.href = "/login";
      }
      console.error(err);
      if (err.response?.status === 422) {
        const validationErrors = err.response.data.errors || {};
        const flattened = Object.fromEntries(
          Object.entries(validationErrors).map(([key, value]) => [
            key,
            Array.isArray(value) ? value[0] : value,
          ])
        );
        setFormErrors(flattened);
        const errorMessages =
          Object.values(flattened).filter(Boolean).join(" ") ||
          "Validation failed.";
        toast.error(errorMessages);
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setbtnLoading(false);
    }
  };

  return (
    
      <Header
        mode={mode}
        updateMessage={"Attendance Break"}
        addMessage={"Attendance Break"}
        homeLink={"/organization/attendance-break"}
        homeText={"Attendance Break"}
        onSubmit={handleSubmit}
        loading={loading}
        btnLoading={btnLoading}>
      {loading ? (
        <Grid container spacing={2}>
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>
               

                 <Autocomplete
                fullWidth
                  options={BreakType || []}
                  getOptionLabel={(option) =>
                    option.attendance_break_type_name || ""
                  }
                  value={
                    BreakType?.find(
                      (option) =>
                        option.organization_attendance_break_type_id ===
                        formData.organization_attendance_break_type_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "organization_attendance_break_type_id",
                        value:
                          newValue?.organization_attendance_break_type_id ||
                          "",
                      },
                    });
                  }}
                  disabled={mode === "view" || BreakType?.length === 0 }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Break Type"
                      error={
                        !!formErrors.organization_attendance_break_type_id
                      }
                      helperText={
                        formErrors.organization_attendance_break_type_id
                      }
                      required
                      fullWidth
                    />
                  )}
                />


                <TextField
                  fullWidth
                  label="Break Name"
                  name="attendance_break_name"
                  disabled={mode === "view"}
                  value={formData.attendance_break_name}
                  onChange={handleChange}
                  error={!!formErrors.attendance_break_name}
                  helperText={formErrors.attendance_break_name}
                  required
                  inputProps={{ maxLength: 100 }}
                />

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  {/* Start Time */}
                  <TimePicker
                  disabled={mode === "view"}
                    label="Start Time"
                    views={["hours", "minutes"]}
                    ampm={true}
                    value={
                      formData.break_start_time
                        ? new Date(`1970-01-01T${formData.break_start_time}`)
                        : null
                    }
                    onChange={(newValue) => {
                      const formatted = newValue
                        ? format(newValue, "HH:mm")
                        : "";
                      setFormData((prev) => ({
                        ...prev,
                        break_start_time: formatted,
                      }));
                      setFormErrors((prev) => ({
                        ...prev,
                        break_start_time: "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        error={!!formErrors.break_start_time}
                        helperText={formErrors.break_start_time}
                        required
                      />
                    )}
                  />

                  {/* End Time */}
                  <TimePicker
                  disabled={mode === "view"}
                    label="End Time"
                    views={["hours", "minutes"]}
                    ampm={true}
                    value={
                      formData.break_end_time
                        ? new Date(`1970-01-01T${formData.break_end_time}`)
                        : null
                    }
                    onChange={(newValue) => {
                      const formatted = newValue
                        ? format(newValue, "HH:mm")
                        : "";
                      setFormData((prev) => ({
                        ...prev,
                        break_end_time: formatted,
                      }));
                      setFormErrors((prev) => ({
                        ...prev,
                        break_end_time: "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        error={!!formErrors.break_end_time}
                        helperText={formErrors.break_end_time}
                        required
                      />
                    )}
                  />
                </LocalizationProvider>

                <FormControlLabel
                  control={
                    <Switch
                    disabled={mode === "view"}
                      checked={
                        formData.is_paid === "1" || formData.is_paid === true
                      }
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          is_paid: e.target.checked,
                        }))
                      }
                      color="primary"
                    />
                  }
                  label="Is Paid"
                />

                {["15", "30", "45", "60"].includes(
                  String(formData.break_duration_minutes)
                ) || formData.break_duration_minutes === "" ? (
                  <TextField
                    select
                 
                    fullWidth
                    disabled={mode === "view"}
                    label="Break Duration (minutes)"
                    name="break_duration_minutes"
                    value={formData.break_duration_minutes}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData((prev) => ({
                        ...prev,
                        break_duration_minutes: value,
                      }));
                    }}
                  >
                    {[15, 30, 45, 60].map((option) => (
                      <MenuItem key={option} value={option}>
                        {option} minutes
                      </MenuItem>
                    ))}
                    <MenuItem value="other">Other</MenuItem>
                  </TextField>
                ) : (
                  <TextField
                    fullWidth
                    type="number"
                    label="Custom Break Duration (minutes)"
                    name="break_duration_minutes"
                    value={formData.break_duration_minutes}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        break_duration_minutes: e.target.value,
                      }))
                    }
                    InputProps={{
                      endAdornment: (
                        <Button
                        disabled={mode === "view"}
                          size="small"
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              break_duration_minutes: "",
                            }))
                          }
                        >
                          Cancel
                        </Button>
                      ),
                    }}
                  />
                )}

                <TextField
                  fullWidth
                  label="Description"
                  disabled={mode === "view"}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  error={!!formErrors.description}
                  helperText={formErrors.description}
                  inputProps={{ maxLength: 255 }}
                  multiline
                  minRows={3} // Minimum visible height
                  maxRows={5}
                />

              
              </Grid>

              <Grid container spacing={2} mt={2}>
                             <Grid item>
                               <Button
                                 variant="contained"
                                 color="primary"
                                 size="medium"
                                 onClick={handleSubmit}
                                 disabled={loading || btnLoading || mode === "view"}
                                 sx={{
                                   borderRadius: 2,
                                   minWidth: 120,
                                   textTransform: "capitalize",
                                   fontWeight: 500,
                                 }}
                               >
                                 {loading || btnLoading ? (
                                   <CircularProgress size={22} sx={{ color: "#fff" }} />
                                 ) : (
                                   "Submit"
                                 )}
                               </Button>
                             </Grid>
             
                             {mode === "edit" && (
                               <Grid item>
                                 <Button
                                   variant="contained"
                                   color="primary"
                                   size="medium"
                                   onClick={() => navigate(-1)}
                                   sx={{
                                     borderRadius: 2,
                                     minWidth: 120,
                                     textTransform: "capitalize",
                                     fontWeight: 500,
                                     backgroundColor: "#1976d2",
                                     "&:hover": { backgroundColor: "#115293" },
                                   }}
                                 >
                                   Cancel
                                 </Button>
                               </Grid>
                             )}
                           </Grid>
            </Paper>
          </Grid>
        </Grid>
      )}
    </Header>
  );
}

export default AttendanceBreakForm;
